import { apiAxios } from '../../../helpers'

export const getList = async (commit, body = {}, params = {}) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .post('matches/', body, { params })
    .finally(_ => commit('updateLoading', false))
  commit('updateList', result.data.data.matches)
}

export const getOne = async (commit, id) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get('matches/' + id)
    .finally(_ => commit('updateLoading', false))
  commit('updateOne', result.data.data.match)
  commit('setScoreId', result.data.data.match.actId)
}

export const getRanking = async (commit, params) => {
  let tournamentId = params.tournamentId
  delete params.tournamentId
  const result = await apiAxios.get('/matches/getRanking/' + tournamentId, {
    params
  })
  commit('updateRanking', result.data.data.ranking)
}

export const getResults = async (commit, tournamentId) => {
  const result = await apiAxios.get('/matches/getResults/' + tournamentId)
  commit('updateResults', result.data.data.results)
}
